// vite version
const EXTENSION_REGEX = /\.[^/.]+$/;

function importAll() {
  // Import all images in the folder eagerly
  const modules = import.meta.glob("images/categories/*.{png,jpg,jpeg,svg,webp}", {
    eager: true,
  });

  let images = {};
  for (const [path, mod] of Object.entries(modules)) {
    // get filename without extension and path
    const fileName = path.split("/").pop();
    if (fileName) {
      const key = fileName.replace(EXTENSION_REGEX, "");
      images[key] = mod.default || mod;
    }
  }

  // Map the special IDs to the image with key "291"
  images = {
    ...images,
    10001: images["291"],
    10002: images["291"],
    10003: images["291"],
    10004: images["291"],
    10005: images["291"],
    10006: images["291"],
    10007: images["291"],
    10008: images["291"],
    10009: images["291"],
    10010: images["291"],
    10011: images["291"],
    10012: images["291"],
    10013: images["291"],
    10014: images["291"],
    10015: images["291"],
    10016: images["291"],
    10017: images["291"],
    10018: images["291"],
    10019: images["291"],
    10020: images["291"],
    10021: images["291"],
    10022: images["291"],
  };

  return images;
}

const artwork = importAll();

export { artwork };
